import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const AIEW_BASE_URL = import.meta.env.VITE_AIEW_URL || "https://ai-edge.io";
const API_BASE_URL = import.meta.env.VITE_API_URL || "";

export default function TvBridgeAuth() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const nonce = searchParams.get("nonce");

  useEffect(() => {
    if (!nonce) {
      setStatus("error");
      return;
    }

    const issueCode = async () => {
      try {
        // Fetch AIEW token directly — no AuthProvider, no redirects
        const tokenResponse = await fetch(`${AIEW_BASE_URL}/api/tokens/optimizer`, {
          method: "POST",
          credentials: "include",
        });

        if (!tokenResponse.ok) {
          setStatus("error");
          return;
        }

        const { accessToken } = await tokenResponse.json();
        if (!accessToken) {
          setStatus("error");
          return;
        }

        // Call auth-code endpoint with the token
        const codeResponse = await fetch(`${API_BASE_URL}/api/v1/tv-bridge/auth-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ nonce }),
        });

        if (!codeResponse.ok) {
          setStatus("error");
          return;
        }

        const { code } = await codeResponse.json();

        if (window.opener) {
          window.opener.postMessage(
            { type: "tv-bridge-code", code, nonce },
            "*"
          );
        }
        setStatus("success");
        setTimeout(() => window.close(), 2000);
      } catch {
        setStatus("error");
      }
    };

    issueCode();
  }, [nonce]);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", fontFamily: "sans-serif" }}>
      {status === "loading" && <p>Connecting to AI Edge Optimizer...</p>}
      {status === "success" && <p>Connected! This window will close automatically.</p>}
      {status === "error" && (
        <div style={{ textAlign: "center" }}>
          <p>Authentication failed.</p>
          <p style={{ fontSize: "14px", color: "#666" }}>
            Make sure you are logged in to the{" "}
            <a href={`${window.location.origin}`} target="_blank" rel="noopener noreferrer">
              AI Edge Optimizer
            </a>{" "}
            in this browser, then try again.
          </p>
        </div>
      )}
    </div>
  );
}
